import { images } from "../constants";
import hailmary3 from "../assets/hailmary3.png";
import { useTranslation } from "react-i18next";

const AgriculturalActivities = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 dark:bg-gray-800">
      {/* First Portion */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <h1 className="text-3xl sm:text-2xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
          {t("alevel.schoolName")}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2 text-xl">
            {t("alevel.schoolSub")}
          </span>
        </h1>
        <img
          src={images.visigalogo}
          alt="Visiga Seminary Logo"
          className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Middle Portion */}
      <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-5">
        <div className="mt-0 text-lg lg:text-center text-neutral-900 dark:text-white w-full px-2">
          {/* Main Section Title */}
          <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold tracking-wide text-center text-gray-900 dark:text-white mb-4">
            {t("agriculture.title")}
          </h2>

          {/* Introduction */}
          <p className="mt-4 text-lg text-justify text-gray-700 dark:text-gray-300">
            {t("agriculture.paragraph")}
          </p>

          {/* Radio Options */}
          <div className="mt-6 w-full flex flex-col items-start">
            <label className="flex items-center space-x-3 text-lg text-neutral-800 dark:text-white">
              <input type="radio" name="activity" className="form-radio" />
              <span>{t("agriculture.cropTitle")}</span>
            </label>
            <label className="flex items-center space-x-3 text-lg text-neutral-800 dark:text-white mt-3">
              <input type="radio" name="activity" className="form-radio" />
              <span>{t("agriculture.livestockTitle")}</span>
            </label>
          </div>

          {/* Crop Farming Section */}
          <h3 className="mt-6 text-2xl font-semibold tracking-wide text-gray-900 dark:text-white">
            {t("agriculture.cropTitle")}
          </h3>
          <p className="mt-2 text-lg text-justify text-gray-700 dark:text-gray-300">
            {t("agriculture.cropText")}
          </p>
          <div className="flex flex-col items-center mt-6">
            <img
              className="rounded-md border border-neutral-300"
              src={images.wine2}
              alt="Student Learning"
              style={{ width: "15cm", height: "10cm", objectFit: "cover" }}
            />
          </div>

          {/* Livestock Farming Section */}
          <h3 className="mt-6 text-2xl font-semibold tracking-wide text-gray-900 dark:text-white">
            {t("agriculture.livestockTitle")}
          </h3>
          <p className="mt-2 text-lg text-justify text-gray-700 dark:text-gray-300">
            {t("agriculture.livestockText")}
          </p>
          <div className="flex flex-col items-center mt-6">
            <img
              className="rounded-md border border-neutral-300"
              src={images.livestock1}
              alt="Student Learning"
              style={{ width: "15cm", height: "10cm", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>

      {/* Third Portion */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <img
          src={hailmary3}
          alt="Hail Mary"
          className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
        />
        <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
          {t("alevel.motherText")}
        </p>
      </div>
    </div>
  );
};

export default AgriculturalActivities;
